import React, { useState } from "react";
import { Table } from "antd";

import InsurancePatientSubTable from "./InsurancePatientSubTable";
import InsuranceAIProcessing from "./InsuranceAIProcessing";
import AddPatientModal from "./AddPatientModal";
import DropdownColumn from "./PatientDropDown";

export default function InsurancePatientsTable({
  loading,
  patients,
  isApproved,
  allPatients,
  allProcedures,
  getAllPatients,
  insuranceStatus,
  allPaymentTypes,
  approvedPatients,
  selectedInsurance,
  paymentTypeOptions,
  setMarkedProcedures,
  selectedPaymentType,
  isApprovingInsurance,
  handleApproveInsurance,
  setSelectedPaymentType,
  handleApprovePostPayment,
  approvedPredeterminations,
  // setEmptyPatientDropdowns,
  predeterminationOrPostPayment,
}) {
  const [isPatientDropdownEmpty, setIsPatientDropdownEmpty] = useState(true);
  const [isSettingPatientId, setIsSettingPatientId] = useState(false);
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [selectedPatients, setSelectedPatients] = useState({});

  const patientInsurancesDetailsColumns = [
    {
      title: "ID",
      key: "id",
      width: 100,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Patient",
      key: "patient_name",
      width: 330,
      render: (_, record) => {
        const hasFullName = record.insurances.every((insurance) => insurance.temp_patient_full_name !== null);
        if (hasFullName) {
          for (let i = 0; i < record.insurances.length; i++) {
            if (record.insurances[i].temp_patient_full_name !== null) return record.insurances[i].temp_patient_full_name;
          }
        } else {
          return `${record.first_name} ${record.last_name}`;
        }
      },
    },
    {
      title: "Related Patient",
      key: "patient_id",
      width: 330,
      render: (_, record) => {
        return (
          <DropdownColumn
            currentPatient={record}
            allPatients={allPatients}
            approvedPatients={approvedPatients}
            setShowAddPatient={setShowAddPatient}
            isSettingPatientId={isSettingPatientId}
            setSelectedPatients={setSelectedPatients}
            selectedInsuranceID={selectedInsurance.id}
            setIsSettingPatientId={setIsSettingPatientId}
            approvedPredeterminations={approvedPredeterminations}
            // setEmptyPatientDropdowns={setEmptyPatientDropdowns}
            setIsPatientDropdownEmpty={setIsPatientDropdownEmpty}
            predeterminationOrPostPayment={predeterminationOrPostPayment}
            disabledByApproved={
              insuranceStatus === "approved" ||
              insuranceStatus === "accepted" ||
              isApproved ||
              (record.insurances.length > 0 && record.insurances.every((insurance) => insurance.is_approved === true))
            }
          />
        );
      },
    },
    {
      title: "Total Amount",
      key: "total_amount",
      width: 330,
      render: (_, record) => {
        if (!record.insurances || record.insurances.length === 0) return "-";
        const total = record.insurances.reduce((sum, insurance) => {
          return sum + parseFloat(insurance.estimated_cost || 0);
        }, 0);
        return `$${total.toFixed(2)}`;
      },
    },
    {
      title: "Insurance Count",
      key: "insurance_count",
      width: 150,
      render: (_, record) => (record.insurances && record.insurances.length) || 0,
    },
  ];

  return (
    <div style={{ borderRadius: 8 }} className="insurance-treatment-table-container">
      {insuranceStatus === "processing" && <InsuranceAIProcessing />}

      <Table
        rowKey="id"
        dataSource={patients}
        columns={patientInsurancesDetailsColumns}
        pagination={{ position: ["bottomCenter"] }}
        scroll={{ x: 1180 }}
        expandable={{
          expandedRowRender: (record) => (
            <InsurancePatientSubTable
              predeterminationOrPostPayment={predeterminationOrPostPayment}
              approvedPredeterminations={approvedPredeterminations}
              handleApprovePostPayment={handleApprovePostPayment}
              isPatientDropdownEmpty={isPatientDropdownEmpty}
              setSelectedPaymentType={setSelectedPaymentType}
              handleApproveInsurance={handleApproveInsurance}
              isApprovingInsurance={isApprovingInsurance}
              selectedPaymentType={selectedPaymentType}
              setMarkedProcedures={setMarkedProcedures}
              paymentTypeOptions={paymentTypeOptions}
              selectedInsurance={selectedInsurance}
              selectedPatients={selectedPatients}
              approvedPatients={approvedPatients}
              insuranceStatus={insuranceStatus}
              allPaymentTypes={allPaymentTypes}
              allProcedures={allProcedures}
              isApproved={isApproved}
              loading={loading}
              record={record}
            />
          ),
          rowExpandable: (record) => record.insurances && record.insurances.length > 0,
        }}
      />

      <AddPatientModal showAddPatient={showAddPatient} setShowAddPatient={setShowAddPatient} getAllPatients={getAllPatients} />
    </div>
  );
}
